(function() {
    angular
        .module('emarket.main.category')
        .controller('CategoryDialogController', ['$log', '$mdDialog', 'Utils', 'Category', function($log, $mdDialog, Utils, Category) {
            var categories = Category.$search({
                parentId: 0
            });
            var vm = this;
            var defaultTitle = 'Escoja la Categoria';
            vm.title = defaultTitle;
            vm.categories = categories;
            var categoryList = [];
            var categoryString = [];
            vm.showBack = false;
            var getCategoryString = function() {
                var title = '';
                var length = categoryString.length;
                categoryString.forEach(function(category, index) {
                    title += category;
                    if (index < length - 1) {
                        title += ' > ';
                    }
                });
                return title;
            };
            vm.searchChild = function(category) {
                Category.$search({
                    parentId: category._id
                }).$then(function(categories) {
                    categoryString.push(category.name);
                    Utils.scrollTo('top', '.category-dialog md-list');
                    if (categories.length === 0) {
                        var plainCategory = {};
                        Object.keys(category).forEach(function(key) {
                            if (!/^\$/.test(key)) {
                                plainCategory[key] = category[key];
                            }
                        });
                        categoryList.push(category);
                        $mdDialog.hide({
                            categories: categoryList,
                            breadcrumbs: getCategoryString(),
                            selected: plainCategory
                        });
                    } else {
                        vm.showBack = true;
                        vm.categories = categories;
                        categoryList.push(category);
                        vm.title = category.name;
                    }
                });
            };
            vm.goBack = function() {
                Utils.scrollTo('top', '.category-dialog md-list');
                categoryList.pop();
                categoryString.pop();
                vm.categories =
          categoryList.length > 0 ? categoryList[categoryList.length - 1] : categories;
                if (categoryList.length === 0) {
                    vm.showBack = false;
                    vm.title = defaultTitle;
                }
            };
            vm.cancel = function() {
                $mdDialog.cancel();
            };
        }]);
}());
